import { Outlet, Route, Routes } from 'react-router-dom'
import PDANavigation from '../components/PDANavigation'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import OrderHistory from '../layouts/OrderHistory'

const OrderHistoryPageBreadCrumbs: Array<PageLink> = [
  {
    title: 'Analytics',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Sold Products',
    path: '/analytics/sold-products/product-report',
    isSeparator: false,
    isActive: false,
  },
]

const OrderHistoryPage = () => {
    return (
        <>
          <Routes>
            <Route
              element={
                <>
                  <PDANavigation />
                  <Outlet />
                </>
              }
            >
              <Route
                path=''
                element={
                  <>
                    <PageTitle breadcrumbs={OrderHistoryPageBreadCrumbs}>Order History</PageTitle>
                    <OrderHistory />
                  </>
                }
              />
            </Route>
          </Routes>
        </>
      )
}

export default OrderHistoryPage